import ListingType from './listing-type';
import ListingUseType from './listing-use-type';
var TitanAdKeyCatValues = {
  BUY: 'buy',
  RENT: 'rent',
  SHARE: 'share',
  SOLD: 'sold',
  FINDANAGENT: 'findanagent',
  NEWHOME: 'newhome',
  DOMAIN: 'domain'
};
var TitanAdKeyCat1Values = {
  SEARCH_RESULTS: 'searchresults',
  MOVING: 'moving',
  DETAILS: 'details',
  BLOGS: 'blogs',
  DESIGN_AND_LIVING: 'designandliving',
  DIY: 'diy',
  GREEN: 'green',
  REAL_ESTATE_NEWS: 'realestatenews'
};
var TitanAdKeyCtypeValues = {
  HOMEPAGE: 'homepage',
  INDEX: 'index',
  ARTICLE: 'article',
  PHOTO_GALLERIES: 'photogalleries'
};
var TitanAdKey = {
  [ListingType.SALES_RESIDENTIAL.name]: {
    cat: TitanAdKeyCatValues.BUY,
    cat2: ListingUseType.RESIDENTIAL
  },
  [ListingType.RENTAL_RESIDENTIAL.name]: {
    cat: TitanAdKeyCatValues.RENT,
    cat2: ListingUseType.RESIDENTIAL
  },
  [ListingType.SHARE_RESIDENTIAL.name]: {
    cat: TitanAdKeyCatValues.SHARE,
    cat2: ListingUseType.RESIDENTIAL
  },
  [ListingType.SALES_COMMERCIAL.name]: {
    cat: TitanAdKeyCatValues.BUY,
    cat2: ListingUseType.COMMERCIAL
  },
  [ListingType.RENTAL_COMMERCIAL.name]: {
    cat: TitanAdKeyCatValues.RENT,
    cat2: ListingUseType.COMMERCIAL
  },
  [ListingType.SALES_RESIDENTIAL.name]: {
    cat: TitanAdKeyCatValues.BUY,
    cat2: ListingUseType.RESIDENTIAL
  },
  [ListingType.SALES_BUSINESS.name]: {
    cat: TitanAdKeyCatValues.BUY,
    cat2: ListingUseType.BUSINESS
  },
  [ListingType.DEVELOPMENTS_RESIDENTIAL.name]: {
    cat: TitanAdKeyCatValues.NEWHOME,
    cat2: ListingUseType.RESIDENTIAL
  }
};
export default TitanAdKey;
export { TitanAdKeyCat1Values, TitanAdKeyCtypeValues };